export default "__VITE_ASSET__BvODFfW2__"